import { useLocation, Link } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";
import { NAV_ITEMS } from "@/lib/constants";

function currentItem(pathname) {
  return (
    NAV_ITEMS.find((n) => pathname === n.to || pathname.startsWith(`${n.to}/`)) ||
    NAV_ITEMS[0]
  );
}

export function useCurrentPageTitle() {
  const { pathname } = useLocation();
  return currentItem(pathname).label;
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const item = currentItem(pathname);
  const isDashboard = item.to === "/dashboard";

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="flex items-center gap-1.5 text-sm"
    >
      <Link
        to="/dashboard"
        className="flex items-center text-muted-foreground transition-colors hover:text-foreground"
        data-testid="breadcrumb-home"
      >
        <Home className="h-4 w-4" />
      </Link>
      {!isDashboard && (
        <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/60" />
      )}
      <span className="font-semibold text-foreground">{item.label}</span>
    </nav>
  );
}
